export enum PageType {
  Cem = 'cem',
  Kam = 'kam',
}
